var _defs, _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWorkdayLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M24.376 6.477a17.617 17.617 0 0 1 16.76 10.469 1.11 1.11 0 0 1 .13.718.989.989 0 0 1-1.89.182 15.622 15.622 0 0 0-10.8-9.057 16.93 16.93 0 0 0-7.15-.002 15.177 15.177 0 0 0-8.566 5.354 14.242 14.242 0 0 0-2.242 3.708.986.986 0 0 1-1.84-.707A17.616 17.616 0 0 1 24.376 6.477",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M40.287 19.439a1.948 1.948 0 0 1-1.814-1.251 14.693 14.693 0 0 0-5.327-6.384 14.486 14.486 0 0 0-4.788-2.075 16.012 16.012 0 0 0-6.743.004 14.296 14.296 0 0 0-8.023 5.038 13.298 13.298 0 0 0-2.087 3.457 1.935 1.935 0 0 1-1.468 1.179 1.74 1.74 0 0 1-.335.03 1.952 1.952 0 0 1-1.822-2.648A18.643 18.643 0 0 1 31.218 6.563a18.76 18.76 0 0 1 8.426 6.045 18.539 18.539 0 0 1 2.373 3.945 2.06 2.06 0 0 1 .19 1.324 1.943 1.943 0 0 1-1.696 1.547 1.677 1.677 0 0 1-.224.014m-25.134-8.802a16.73 16.73 0 0 0-5.48 6.871l.057-.039a15.279 15.279 0 0 1 2.398-3.955 19.701 19.701 0 0 1 3.025-2.877m19.986.224a16.666 16.666 0 0 1 5.125 6.608l.014.025.032-.032c-.01-.018-.023-.053-.046-.104a16.594 16.594 0 0 0-5.125-6.497M24.994 7.431c-.194 0-.39.004-.585.01a16.6 16.6 0 0 0-2.592.292 19 19 0 0 1 4.426-.256q-.619-.045-1.249-.046",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M8.302 22.094h33.396V44.5H8.302z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "d"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M7.751 21.377h35.28v24.696H7.751z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "e"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M8.302 22.58a1.018 1.018 0 0 1 .797-.472c1.015-.008 2.03-.031 3.043.014a1.054 1.054 0 0 1 .946.946c.995 4.054 1.974 8.113 2.967 12.168.29 1.253.645 2.493.834 3.766.196 1.143.235 2.306.422 3.452a43.549 43.549 0 0 1 .926-4.882l3.893-14.516a1.196 1.196 0 0 1 1.171-.944c1.13-.028 2.26-.009 3.389-.009a1.347 1.347 0 0 1 1.399.946c.97 3.528 1.926 7.063 2.891 10.592a63.423 63.423 0 0 1 1.685 6.882c.093.647.181 1.295.315 1.937a96.451 96.451 0 0 1 2.093-10.884c.643-2.872 1.273-5.747 1.924-8.62a1.164 1.164 0 0 1 1.244-.85c.914-.005 1.827-.031 2.74.015a.794.794 0 0 1 .66 1.097q-2.748 10.137-5.489 20.275a1.18 1.18 0 0 1-1.122.974c-1.414.046-2.833.01-4.246.02a1.023 1.023 0 0 1-1.132-.775c-1.267-4.648-2.507-9.301-3.763-13.953a31.603 31.603 0 0 1-.827-4.957 41.223 41.223 0 0 1-.745 4.442q-1.923 7.184-3.861 14.368c-.145.776-1.032.93-1.692.88-1.316-.025-2.63.03-3.944-.025a.952.952 0 0 1-.914-.806q-2.77-10.095-5.533-20.193a5.18 5.18 0 0 1-.071-.889",
    clipRule: "evenodd"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "workday") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f69f1a",
    d: "M-.105-2.354h50.209v29.646H-.105z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f69f1a",
    d: "M-1.069-3.32H51.07v31.579H-1.069z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#d)",
    style: {
      isolation: "isolate"
    }
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#e)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#d)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0067ab",
    d: "M-.518 13.274h51.036V53.32H-.518z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkdayLogo);
export default __webpack_public_path__ + "static/media/workdayLogo.19c2eebb1eb7dd23db1ccec815644760.svg";
export { ForwardRef as ReactComponent };